import { useEffect } from 'react';

function useModalFocusTrap({
	modalRef,
	requestClose,
	initialFocusRef,
	initialFocusSelector,
	focusableSelector = 'button, input[type="radio"]',
}) {
	useEffect(() => {
		const modalElement = modalRef.current;
		const initialFocusElement = initialFocusSelector
			? modalElement?.querySelector(initialFocusSelector)
			: initialFocusRef?.current;

		initialFocusElement?.focus();

		const handleKeyDown = event => {
			if (event.key === 'Escape') {
				requestClose();
				return;
			}

			if (event.key !== 'Tab' || !modalElement) {
				return;
			}

			const focusable = Array.from(modalElement.querySelectorAll(focusableSelector)).filter(
				element => !element.disabled
			);

			if (focusable.length === 0) {
				return;
			}

			const first = focusable[0];
			const last = focusable[focusable.length - 1];

			if (event.shiftKey ? document.activeElement === first : document.activeElement === last) {
				event.preventDefault();
				(event.shiftKey ? last : first).focus();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [focusableSelector, initialFocusRef, initialFocusSelector, modalRef, requestClose]);
}

export default useModalFocusTrap;